import { render } from "./LoadMoreTrigger.vue?vue&type=template&id=dcf700ce"
import script from "./LoadMoreTrigger.vue?vue&type=script&lang=js"
export * from "./LoadMoreTrigger.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__